<script setup lang="ts">
withDefaults(defineProps<{ count?: number }>(), { count: 2 });
</script>

<template>
  <div class="flex flex-col gap-8">
    <div
      v-for="i in count"
      :key="i"
      class="flex flex-col gap-2"
    >
      <div class="flex items-center justify-between">
        <UiSkeleton class="h-3 w-20" />
        <UiSkeleton class="h-3 w-24" />
      </div>
      <UiSkeleton class="h-11 w-full" />
      <UiSkeleton class="h-11 w-full" />
      <UiSkeleton class="h-11 w-full" />
    </div>
  </div>
</template>
